import { ReportsMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenu";

export { ReportsMenu };
